import { AbstractDropdownSelection } from "./AbstractDropdownSelection";
import * as fuzzysort from "fuzzysort";
import TextField from "../../../lib/ui/controls/TextField";
export class SearchSelection extends AbstractDropdownSelection {
    constructor(options, items) {
        super(options, items[0]);
        this.options = options;
        this.items = items;
        this.prepared_items = items.map(i => {
            return { item: i, term: fuzzysort.prepare(this.options.search_term(i)) };
        });
        this.setItems([]);
    }
    onOpen() {
        let search_box = new TextField()
            .setValue("")
            .css("width", "100%")
            .onPreview(term => {
            let results = fuzzysort.go(term, this.prepared_items, {
                key: "term",
                all: true,
                threshold: -10000
            });
            this.setItems(Array.from(results).map(r => r.obj.item));
        })
            .appendTo(this.input_container.empty());
        this.setItems(this.items);
        return search_box;
    }
}
